module.exports = {
  siteDescription: 'Noticias de último minuto de K-Pop y K-Drama, exclusivas y videos',
  cookieConsent: {
    banner: 'Utilizamos cookies para mejorar nuestros servicios, personalizar el contenido y mostrar anuncios según tus intereses. Al continuar utilizando este sitio web, nos das tu consentimiento para hacerlo.',
    title: 'Configuración de cookies',
    tabs: {
      whatCookie: {
        title: '¿Qué son las Cookies?',
        toggle: '',
        content: [
          'Cuando visitas cualquier sitio web este puede almacenar o recuperar información en tu navegador, principalmente en forma de cookies. Esta información puede ser sobre ti, tus preferencias o tu dispositivo y se utiliza principalmente para hacer que el sitio funcione como se espera. La información no suele identificarte directamente, pero puede brindarte una experiencia web más personalizada.',
          'Debido a que respetamos tu derecho a la privacidad, puedes optar por no permitir algunos tipos de cookies. Haz clic en los diferentes encabezados de categoría para obtener más información y cambiar nuestra configuración predeterminada. Sin embargo, el bloqueo de algunos tipos de cookies puede afectar tu experiencia del sitio y los servicios que podemos ofrecer.'
        ]
      },
      siteFunctions: {
        title: 'Cookies de funcionalidad del sitio',
        toggle: 'Siempre Encendido',
        content: [
          'Utilizamos cookies para proporcionarte las funciones y la experiencia de usuario prometida de los Sitios (por ejemplo, estas cookies pueden ayudarnos a mantener un registro de las preferencias de los usuarios). Utilizamos cookies para habilitar nuestras funciones de seguridad y para ayudarnos a detectar actividades que infringen nuestras políticas (por ejemplo, estas cookies pueden ayudarnos a evitar el spam). Utilizamos cookies para verificar tu cuenta y personalizar tu experiencia (por ejemplo, estas cookies pueden ayudarnos a mantenerte conectado mientras navegas entre las páginas del Sitio).'
        ]
      },
      performance: {
        title: 'Rendimiento, Análisis Estadístico e Investigación',
        toggle: '',
        content: [
          'Utilizamos cookies para recopilar información sobre como se utilizan los Sitios e informar sobre las estadísticas de uso de los Sitios para mejorar nuestros servicios (por ejemplo, estas cookies pueden ayudarnos a contar visitas, páginas vistas, fuentes de tráfico y comprender mejor cómo tú y otros usuarios usan Nuestros Sitios e identificar funciones que podrían mejorarse).'
        ]
      },
      socialMedia: {
        title: 'Medios Sociales',
        toggle: '',
        content: [
          'Usamos cookies que son establecidas por una gama de servicios de medios sociales que hemos agregado a Nuestros Sitios para permitirte compartir Nuestro contenido con tus amigos y redes. Son capaces de rastrear tu navegador a través de otros sitios. Esto puede afectar el contenido y los mensajes que ves en otros sitios web que visitas (por ejemplo, estas cookies pueden ayudar a los servicios de redes sociales a mejorar tu perfil de intereses).'
        ]
      },
      advertising: {
        title: 'Publicidad y Remercadeo.',
        toggle: '',
        content: [
          'Nosotros y nuestros socios publicitarios podemos recopilar información utilizando cookies para ayudar a que la publicidad que ves en los Sitios y en cualquier otro lugar de Internet sea más relevante para ti, y para medir la efectividad de la publicidad en los Sitios (por ejemplo, estas cookies pueden ayudarnos a Nosotros y nuestros socios publicitarios a mostrarte anuncios útiles y relevantes de manera más efectiva).'
        ]
      }
    }
  },
  sorts: {
    latest: 'Lo último',
    popular: 'Popular',
    trending: 'Tendencias'
  },
  sortpages: {
    latest: 'Todas las últimas publicaciones',
    popular: 'Todas las publicaciones populares',
    trending: 'Todas las publicaciones en tendencia'
  },
  buttons: {
    submitTip: 'Envíanos información',
    submitTipTitle: 'Haz clic para enviarnos información',
    watchNow: 'Ver ahora',
    loadMore: 'Cargar más',
    seeAll: 'Ver todo',
    allowAll: 'Permitir todo',
    learnMore: 'Leer más',
    save: 'Guardar',
    cancel: 'Cancelar',
    nightMode: 'Modo Nocturno',
    customize: 'Personalizar',
    update: 'Actualizar cambios',
    manage: 'Administrar Rakuten ID',
    backHome: 'Volver al inicio',
    submit: 'Envíar',
    close: 'Cerrar'
  },
  dates: {
    justNow: 'Justo ahora',
    yesterday: 'Ayer',
    min: 'Hace {0} min',
    mins: 'Hace {0} mins',
    hour: 'Hace {0} hora',
    hours: 'Hace {0} horas',
    day: 'Hace {0} dia',
    days: 'Hace {0} dias',
    week: 'Hace {0} semana',
    weeks: 'Hace {0} semanas'
  },
  search: {
    title: 'Buscar',
    textbox: 'Buscar Articulos',
    noResult: 'Lo sentimos, no podemos encontrar resultados de {0}',
    error: 'Lo sentimos, tenemos problemas para obtener resultados del servidor. Por favor inténtalo de nuevo.',
    result: 'Resultados de búsqueda de "{0}"'
  },
  login: {
    title: '¡Inicia sesión en Soompi y comienza a participar!',
    facebookPrompt: 'Iniciar sesión con Facebook',
    googlePrompt: 'Inicia sesión con Google',
    tocPrompt: 'Por favor acepta nuestros términos antes de crear la cuenta.',
    toc: 'Al crear una cuenta, aceptas los {0} y {1} de Soompi. Soompi es parte de la familia Rakuten Viki.',
    privacyLinkCta: 'Política de privacidad',
    termsOfUseLinkCta: 'Términos de uso'
  },
  logout: {
    title: 'Cerrar sesión'
  },
  profile: {
    title: 'Perfil',
    dropdownWelcomeTitle: '¡Bienvenido de nuevo, {0}!',
    edit: 'Editar Perfil',
    displayName: 'Nombre para mostrar',
    share: 'Comparte tus historias',
    storyLimitWarning: 'El texto no debe tener más de 500 caracteres.',
    email: 'Dirección de correo electrónico (invisible para otros)',
    manage: 'Administra la configuración de tu cuenta como la dirección de correo electrónico, la cuenta social y la contraseña a través del portal de Rakuten ID',
    editImage: 'Cambiar<br/>Foto',
    update: 'Actualizar cambios',
    updateError: 'Error al actualizar el perfil. Inténtalo de nuevo',
    updateSuccess: '¡Perfil actualizado con éxito!'
  },
  general: {
    explore: 'Explorar',
    spotlight: 'Soompi Originales',
    related: 'Relacionado',
    popular: 'Popular',
    trending: 'Tendencias',
    trendingNow: 'Tendencia actual',
    latestNews: 'Últimas noticias',
    watchNow: 'Ver ahora',
    mustRead: 'Debes leer',
    similarArticle: 'Artículos similares',
    comments: 'Comentarios',
    shareit: 'Compartir en',
    authors: 'Artículos de {0}'
  },
  footer: {
    links: {
      about: 'Acerca de Nosotros',
      terms: 'Términos de Uso',
      privacy: 'Política de Privacidad',
      cookie: 'Política de Cookies',
      copyright: 'Política de Derechos de Autor',
      help: 'Centro de Ayuda',
      adInfo: 'Información Publicitaria',
      guide: 'Directrices del sitio',
      jobs: 'Ocupaciones',
      apps: 'Apps'
    },
    family: 'Soompi es parte de la familia {0}',
    language: 'Idioma',
    english: 'English',
    spanish: 'Español',
    follow: 'Síguenos',
    sitemap: 'Mapa de sitio'
  },
  rss: {
    linkBack: 'La publicación {0} apareció primero en {1}',
    pagination: 'Página {0}'
  },
  notFound: '¡La página que buscas parece haberse perdido!',
  submitTip: {
    title: 'Envíanos información',
    text1: '¿Tienes noticias de último minuto o fotos sobre K-Pop o K-Drama? ¡Dile a nuestro equipo de noticias ahora y seguiremos la información!',
    text2: 'Por favor, incluye una descripción y una URL si corresponde.',
    formFieldsRequired: 'Todos los campos son obligatorios.',
    formName: 'Nombre',
    formEmail: 'Email',
    formContent: '¿Cuál es la información?',
    alertFail: 'Error al enviar tu información, por favor intenta de nuevo más tarde.',
    alertSuccess: '¡Gracias por la información! Nuestros editores la leerán pronto.'
  },
  reactions: {
    title: '¿Cómo te hace sentir este artículo?',
    dialogTitle: '¡Espera!',
    dialogText: 'Estás a un paso de expresar tu emoción por este artículo, inicia sesión para participar con el resto.'
  },
  comment: {
    dialogTitle: '',
    loginCta: '¡{0} en Soompi para unirte a la conversación!',
    loginCtaButton: 'inicia sesión'
  }
}



// WEBPACK FOOTER //
// ./i18n/lang/es.js